import React from "react";
import StatusERTDetailsPage from "./views/StatusERTDetailsPage";
import { StatusERTDetailsContextProvider } from "./StatusERTDetailsView";
import StatusContents from "../../constants/contentFile.json";

const ERTDetailView = () => {
  return (
    <StatusERTDetailsContextProvider>
      <StatusERTDetailsPage textContents={StatusContents.status} />
    </StatusERTDetailsContextProvider>
  );
};
export default ERTDetailView;
